import $, { contains } from "jquery"
import {initializeModalControls, effectModalShowBodyReset, deactivateReadySpinnerModal} from './modals-control'
import {FbPixelTrackAddToCartEvent} from './pixels'
// import Globalize, { currencyFormatter } from  "globalize";
// import cldr_data from "cldr-data";
// import iana_tz_data  from "iana-tz-data" 

// Globalize.load( cldr_data.entireSupplemental() );
// Globalize.load( cldr_data.entireMainFor( "en", "es" ) );
// Globalize.loadTimeZone( iana_tz_data );

// export var Globalize = require( "globalize" );
// Globalize.load( require( "cldr-data" ).entireSupplemental() );
// Globalize.load( require( "cldr-data" ).entireMainFor( "en", "es" ) );
// Globalize.loadTimeZone( require( "iana-tz-data" ) );

// https://codepen.io/bviljoen/pen/XWJdQEX

// ************************************************
// Shopping Cart API
// ************************************************

// Declare Cart Items Type 
export var ProductsType // welfare or regular
export var IsWelfareProducts // true or false
export var IsComboPage // true or false
export var IsCollaboPage // true or false
export var DisplayCartOnPageLoad // true or false
export var SelectedWelfareLevel = 100 // will be updated when customer chooses welfare level
export var WelfareLevelSet = false
export var cartItemsButtonClickTriggered = false

// Export Global Variables for Mega Promo
window.CollaboPackage = ""
window.CollaboPackageCode = ""
window.CollaboPackageDuration = ""

var ComboEbookCode = "", ComboEbookName = ""
var RebuildComboCart = false, OneCycleStandard, SelectedEbookData

// Cart variables for orderPage and orderExtraInfo
var XderPage ="default"
var XtraZnfo = "default"

// From the model
const OneCycleStandardCode = "STANDARD_COACHING_1C" 

var containsFullPackage, containsCoaching, containsTeaching, containsEguide, recommendedProductsRender

var welfareTotalAmount = document.getElementById('welfare-total-amount')
var welfareLevelAmount = document.getElementById('welfare-level-amount')
var welfarePricingContainer = document.getElementById('welfare-pricing-container')

export var welfarePackagePrice;
export var welfarePackageFormattedPrice;


// ==========================================
// =========== START EVENT LISTENERS ========
// ==========================================

// Event Listener for claim-collabo-offer (incomplete)
export function claimCollaboOfferClicked(event) {

    // Run when event occurs
    // Clear cart
    shoppingCart.clearCart();

    if (CollaboPackageCode == "") {
        // Todo Show error You have not selected a collabo package
        // Not necessary. CollaboPackage will always default to one cycle for the selected category (vip, standard or welfare)
        return
    }

    // Get the selected coaching package data from server sent packages
    const selectedCoachingPackageData = siteCoachingPackageByCode[CollaboPackageCode]

    if (selectedCoachingPackageData == null) { 
        console.log("could not get selected coaching package from siteCoachingPackageByCode")
        return
    }

    // Get required data and add to cart
    var quantity = 1;
    var welfare_level = 100;
  
    // Get Standard one cycle data and add to cart.
    var name = selectedCoachingPackageData.product_name
    var code = selectedCoachingPackageData.product_code;  
    var price = Number(selectedCoachingPackageData.product_price)
  
    var base_price = price

    // Add to cart and render cart
    AddSelectedItemToCart(name, code, base_price, price, quantity)

    RebuildComboCart = false

    // Click collabo display cart button
    document.querySelector('.collabo-display-cart').click();
}


// Event Listener function Run when event occurs
export function comboOfferEbookSelected(event) {

  // Hide the error message when change event is received
  handleEbookSelectErrorMsg("hide")
  
  // When an eBook is selected, set the code for the eBook in the global variable

  ComboEbookCode = event.target.value;
  ComboEbookName = event.target.options[event.target.selectedIndex].text;  

  if (ComboEbookCode == "") {
    console.log("no ebook selected")
    handleEbookSelectErrorMsg("show")
    return
  }

  console.log("ebook selected")

  // use ebook code to fetch ebook data from
  // SelectedEbookData = siteEbooksByCode[ComboEbookCode] 

  // if (ebookData == null){
  //   console.log("no ebook product was found with code: ", ComboEbookCode)
  //   return
  // }
}

function handleEbookSelectErrorMsg(state) {
  const errorElem = document.querySelector('.no-ebook-selected-err')
  if (state == "show") {
    errorElem.classList.add("flex");
    errorElem.classList.remove("hidden");
  }

  if (state == "hide") {
    errorElem.classList.add("hidden");
    errorElem.classList.remove("flex");
  }
}

// For those who aren't logged in, after log in, they won't setComboMegaRide
export function setComboPageExtraInfo(){
  // if url contains combo || promo. We are using /promo to advertise combo package on Facebook (Careful here)
  if (urlContains("combo") || urlContains("promo")) {
    // Set Global Window Variable XtraZnfo
    XtraZnfo = "combo-mega-ride"
  }
}

// For those who aren't logged in, after log in, they won't setComboMegaRide
export function setCollaboPageExtraInfo(){
  // if url contains collabo
  if (urlContains("collabo")) {
    // Set Global Window Variable XtraZnfo
    // Skip price adjustments
    XtraZnfo = "skip"
  }
}

// Add Custom Pages Extra info
export function addCustomPagesExtraInfo(){
  setComboPageExtraInfo()
  setCollaboPageExtraInfo()
}

// Check if url contains sustring
export function urlContains(substring) {
  // Get the current URL using window.location.href
  var currentUrl = window.location.href;

  // Modern approach using includes
  // return window.location.href.includes(substring);

  // Check if the substring is present (supports Internet explorer)
  return currentUrl.indexOf(substring) !== -1;
}

// Event Listener Run when event occurs
export function claimComboOfferClicked(event){
    // Set Global Window Variable XtraZnfo
    XtraZnfo = "combo-mega-ride"

    // Run when event occurs
    // Clear cart
    shoppingCart.clearCart();

    // Check if ComboEbookCode is set
    if (ComboEbookCode == "") {
      console.log("ComboEbookCode is not set")
      handleEbookSelectErrorMsg("show")
      return
    }

    // Get StandardOneCycle data from server sent packages
    OneCycleStandard = siteCoachingPackageByCode[OneCycleStandardCode]

    if (OneCycleStandard == null) { 
      console.log("could not get one cycle standard coaching package from siteCoachingPackageByCode")
      return
    }

    // Get the eBook Data from the server sent eBooks
    SelectedEbookData = siteEbooksByCode[ComboEbookCode]
    if (SelectedEbookData == null) { 
      console.log("could not get selected ebook data from siteEbooksByCode")
      return
    }

    // Get the data of the ebook and the One Month Standard Coaching package and build a suitable display name for the combo product. Price 

    var name = "One Cycle Standard Coaching PLUS " + ComboEbookName
    var code = "COMBO_" + OneCycleStandard.product_code;
    
    var price = Number(OneCycleStandard.product_price) + Number(SelectedEbookData.product_price);

    var base_price = price
    var quantity = 1;
    var welfare_level = 100;

    AddSelectedItemToCart(name, code, base_price, price, quantity)

    // Set a flag so that when proceed to submit cart, we rebuild with standard backend product codes,
    RebuildComboCart = true

    // Click combo display cart button
    document.querySelector('.combo-display-cart').click();

    // We can just proceed to rebuild so those who aren't logged will get the correct price and not 0 because the button they click is to log in and when they return, claimComboOfferClicked will not be run, RebuildComboCart will be false, so the COMBO code will be sent to backend resulting in 0
    rebuildComboCartWithIndividualItems()
}

// ==============================================
// ============== END EVENT LISTENERS ===========
// ==============================================

// Add Standard Coaching One Cycle, and the Selected eBook to cart
// For backend use
function rebuildComboCartWithIndividualItems() {

  // Clear Cart
  shoppingCart.clearCart();

  var quantity = 1;
  var welfare_level = 100;

  // Get Standard one cycle data and add to cart.
  // Override the Coaching Package Name
  var name = "One Cycle Standard Coaching PLUS eBook"
  // var name = OneCycleStandard.product_name
  var code = OneCycleStandard.product_code;  
  var price = Number(OneCycleStandard.product_price)

  var base_price = price

  AddSelectedItemToCartNoRender(name, code, base_price, price, quantity)
  
  // Get ebook data and add to cart
  name = SelectedEbookData.product_name
  code = SelectedEbookData.product_code;  
  price = Number(SelectedEbookData.product_price)

  base_price = price
  AddSelectedItemToCartNoRender(name, code, base_price, price, quantity)

  // Already rebuilt
  RebuildComboCart = false
}

// ===============================================

export var shoppingCart = (function () {
  // =============================
  // Private methods and propeties
  // =============================
  let cart = [];

  let currency = getCurrency();
  let currency_symbol = getCurrencySymbol();

  // Constructor
  function Item(name, code, base_price, price, quantity, type, welfare_level, welfare_price ) {

    this.name = name;
    this.code = code;
    this.item_type = type;
    this.quantity = Number(quantity);
    this.base_price = base_price; // original price loaded from backend on which calculations or welfare price action is based
    this.price = price;
    this.welfare_price = welfare_price;
    this.welfare_level = Number(welfare_level);
    this.currency = currency
    this.currency_symbol = currency_symbol
  }

  // Save cart
  function saveCart() {
    sessionStorage.setItem("shoppingCart", JSON.stringify(cart));
  }

  // Load cart
  function loadCart() {
    cart = JSON.parse(sessionStorage.getItem("shoppingCart"));
  }
  //Load Cart if shoppingCart exists
  if (sessionStorage.getItem("shoppingCart") != null) {
    loadCart();
  }
  
  // =============================
  // Public methods and propeties
  // =============================
  var obj = {};

  // Add to cart or update quantity if exists
  obj.addItemToCart = function (name, code, base_price, price, quantity, type, welfare_level, welfare_price) {
    // Perform update if the item is already in the cart

    for (var item in cart) {
      if (cart[item].name === name) {
        // Do not increase quantity here. User can do that with + or - controls
          // cart[item].quantity++;
        
        // If cart update and it's a welfare product, recalculate the the selected welfare level which could have been changed
        if (IsWelfareProducts) {
          cart[item].welfare_price = ((SelectedWelfareLevel / 100) * cart[item].base_price)
          cart[item].price = cart[item].welfare_price;
        }
        saveCart();
        return;
      }
    }

    // Use price for calculation of new items, since base price is not set yet
    if (isWelfareProduct(name, code)) {
      welfare_price = ((SelectedWelfareLevel / 100) * base_price)
      // Set welfare price as the effective price
      price = welfare_price;
    }

    var item = new Item(name, code, base_price, price, quantity, type, welfare_level, welfare_price );
    cart.push(item);
    saveCart();

    /*******************************
    *******************************/
    // Cool place to report AddToCart Event (Only for unique add to cart events)
    // This fbq code is added globally, so see if we can target it here without importing a module
    FbPixelTrackAddToCartEvent()
    /*******************************
    *******************************/
  };


  // Set quantity item quantity
  obj.setQuantityForItem = function (name, quantity) {
    for (var item in cart) {
      if (cart[item].name === name) {
        cart[item].quantity = quantity;
        break;
      }
    }
  };

  // Increment quantity for item
  obj.incrementQuantityForItem = function (name, quantity) {
    for (var item in cart) {
      if (cart[item].name === name) {
        cart[item].quantity++;
        break;
      }
    }
  };
  // Remove item from cart
  obj.removeItemFromCart = function (name) {
    for (var item in cart) {
      if (cart[item].name === name) {
        cart[item].quantity--;
        if (cart[item].quantity === 0) {
          // cart.splice(item, 1);
          // convert item which is actually index to number
          let index = Number(item)
          cart.splice(index, 1);
        }
        break;
      }
    }
    saveCart();
  };

  // Remove all items from cart
  obj.removeSingleSpecificCartItem = function (name) {
    for (var item in cart) {
      if (cart[item].name === name) {
        // cart.splice(item, 1);
        // convert item which is actually index to number
        let index = Number(item)
        cart.splice(index, 1);
        break;
      }
    }
    saveCart();
  };

  // Remove all regular product items from cart
  obj.removeRegularProductFromCart = function () {
    for (var item in cart) {
      // if cart item name or code doesn't include welfare, then it's a regular product
      let cartItemName = cart[item].name
      let cartItemCode = cart[item].code
      if (isRegularProduct(cartItemName, cartItemCode) ) {
        // cart.splice(item, 1);
        // convert item which is actually index to number
        let index = Number(item)
        cart.splice(index, 1);
        // Don't break here //break;
      }
    }
    saveCart();
  };

  // Remove all welfare product items from cart
  obj.removeWelfareProductFromCart = function () {
    for (var item in cart) {
      // if cart item name or code includes welfare, then it's a welfare product
      let cartItemName = cart[item].name
      let cartItemCode = cart[item].code
      if (isWelfareProduct(cartItemName, cartItemCode)) {
        // cart.splice(item, 1);
        // convert item which is actually index to number
        let index = Number(item)
        cart.splice(index, 1);
      }
    }
    saveCart();
  };

  // Clear cart
  obj.clearCart = function () {
    cart = [];
    saveCart();
  };

  obj.getCart = function () {
    return cart;
  };

  obj.getCartItemCount = function () {
    return cart.length;
  };

  // total cart items count
  obj.totalCartItemsCount = function () {
    var totalItemsCount = 0;
    for (var item in cart) {
      totalItemsCount += cart[item].quantity;
    }
    return totalItemsCount;
  };

  // Total cart
  obj.totalCart = function () {
    var totalCart = 0;
    this.isWelfareProduct
    for (var item in cart) {
      // Calculate cart total based on the product type
      // if (IsWelfareProducts || isWelfareProduct(cart[item].name, cart[item].code)) {
      //   totalCart += cart[item].welfare_price * cart[item].quantity;
      // } else {
        totalCart += cart[item].price * cart[item].quantity;
      // }
    }
    totalCart = Number(totalCart.toFixed(2));
    return parseFloat(totalCart);
  };

  // List cart
  obj.listCart = function () {
    var cartCopy = [];
    for (var item in cart) {
      item = cart[item];
      var itemCopy = {};
      for (var p in item) {
        if (p == "welfare_level" || p == "quantity"){
          // console.log("is welfare level", p)
          itemCopy[p] = Number(item[p])
        } else {
          itemCopy[p] = item[p];
        }
        
      }
      // Calculate item total based on product type
      // if (IsWelfareProducts || isWelfareProduct(item.name, item.code)) {
      //   let total = Number(item.welfare_price * item.quantity).toFixed(2);
      //   // total = parseFloat(total)
      //   itemCopy.total = total;
      // } else {
        let total = Number(item.price * item.quantity).toFixed(2);
        // total = parseFloat(total)
        itemCopy.total = total;
      // }
      
      // Add extra item_total key for backend use
      itemCopy.item_total = itemCopy.total

      cartCopy.push(itemCopy);
    }
    return cartCopy;
  };

  // cart : Array
  // Item : Object/Class
  // addItemToCart : Function
  // removeItemFromCart : Function
  // removeSingleSpecificCartItem : Function
  // totalCartItemsCount : Function
  // clearCart : Function
  // totalCart : Function
  // listCart : Function
  // saveCart : Function
  // loadCart : Function
  return obj;
})();


// *****************************************
// Triggers / Events
// *****************************************

$(function() {
  console.log( "ready!" );

  // Deactivate Getting Ready... Spinner on Services page ready
  initializeModalControls();
  deactivateReadySpinnerModal();


  // Clear items
  $(".clear-cart").on("click", function () {
    shoppingCart.clearCart();
    renderCart();
  });

  // Add event listeners to parent for dynamic elements

  // Delete item button

  // Maybe use document.Ready

  $(".show-cart").on("click", ".delete-item", function (event) {
    var name = $(this).data("name");
    shoppingCart.removeSingleSpecificCartItem(name);
    renderCart();
  });

  // -1
  $(".show-cart").on("click", ".minus-item", function (event) {
    var name = $(this).data("name");
    shoppingCart.removeItemFromCart(name);
    renderCart();
  });
  // +1
  $(".show-cart").on("click", ".plus-item", function (event) {
    var name = $(this).data("name");
    shoppingCart.incrementQuantityForItem(name);
    renderCart();
  });

  // Item quantity input
  $(".show-cart").on("change", ".item-quantity", function (event) {
    var name = $(this).data("name");
    var quantity = Number($(this).val());
    // normalize quantity
    if (quantity <= 0){
      quantity = 1
    }
    shoppingCart.setQuantityForItem(name, quantity);
    renderCart();
  });

  // Click to Add Item
  $(".show-cart").on("click", ".add-item-to-cart", function () {
    hideCart()
    // Close Modal
  });


  // Add item
  $(".add-to-cart").on("click", function(event){
    event.preventDefault();
    var name = $(this).data("name");
    var code = $(this).data("code");
    var price = Number($(this).data("price"));
    var base_price = price
    var quantity = 1;
    var welfare_level = 100;

    /*
      console.log("price is: ", price)
      console.log("base price is: ", base_price)
      console.log("welfare level is: ", welfare_level)
      console.log("welfare quantity is: ", quantity)
      console.log("===============Add to Cart====================")    
   */
    AddSelectedItemToCart(name, code, base_price, price, quantity)

  });

  // Add item to Cart Without Rendering the cart
  $(".add-to-cart-no-render").on("click", function(event){
    event.preventDefault();
    var name = $(this).data("name");
    var code = $(this).data("code");
    var price = Number($(this).data("price"));
    var base_price = price
    var quantity = 1;
    var welfare_level = 100;

    /*
      console.log("price is: ", price)
      console.log("base price is: ", base_price)
      console.log("welfare level is: ", welfare_level)
      console.log("welfare quantity is: ", quantity)
      console.log("===============Add to Cart====================")    
   */
    AddSelectedItemToCartNoRender(name, code, base_price, price, quantity)

  });


  // Get welfare product data from welfare-proceed-to-cart button and add to cart
  let welfare_proceed_to_cart = document.getElementById('welfare-proceed-to-cart')
  if (welfare_proceed_to_cart !== null) {
    welfare_proceed_to_cart.addEventListener("click", function(event) {
      event.preventDefault();
      // Clear the shopping cart first before adding item to avoid calculation complications, since only one welfare product can be ordered per time
      shoppingCart.clearCart()

      var name = welfare_proceed_to_cart.getAttribute('data-name');
      var code = welfare_proceed_to_cart.getAttribute('data-code');
      var price = Number(welfare_proceed_to_cart.getAttribute('data-price'));
      // var price = Number($(this).data("price"));
      var base_price = price
      var quantity = 1;

      let welfare_level = SelectedWelfareLevel

      /*
        console.log("price is: ", price)
        console.log("base price is: ", base_price)
        console.log("welfare level is: ", welfare_level)
        console.log("welfare quantity is: ", quantity)      
        console.log("===============Add to Cart====================")   
      */

      // Add the selected welfare product to cart
      AddSelectedItemToCart(name, code, base_price, price, quantity)
      // We will handle the changes with --pb-modal and --pb-modal-close events attached to the proceed button to close it's parent modal and open the cart modal
    })
  }

  $(".add-to-welfare-proceed-to-cart").on("click", function (event) {
    event.preventDefault();

    // transfer data attributes to welfare-proceed-to-cart button
    let welfare_proceed_to_cart = $('#welfare-proceed-to-cart')
    // https://stackoverflow.com/questions/14935191/adding-data-attribute-to-dom
    // https://stackoverflow.com/a/14935227 (.data doesn't create an actual data- attribute)
    if (welfare_proceed_to_cart !== null) {
      welfare_proceed_to_cart.attr("data-code", $(this).data("code"))
      welfare_proceed_to_cart.attr("data-name", $(this).data("name"))
      welfare_proceed_to_cart.attr("data-price", $(this).data("price"))
      welfare_proceed_to_cart.attr("data-formatted_price", $(this).data("formatted_price"))
      welfare_proceed_to_cart.attr("data-currency", $(this).data("currency"))
      welfare_proceed_to_cart.attr("data-currency-symbol", $(this).data("currency-symbol"))
      // document.getElementById("someElement").setAttribute("data-id", 2);

      // Set formatted price for clicked welfarePackage
      welfarePackagePrice = $(this).data("price");
      welfarePackageFormattedPrice = $(this).data("formatted_price");

      // Display the welfare package pricing based on selected welfare level
      displayWelfarePricingContainer()
    }
    renderCart();
  });

  // ============ Add WelfareLevelSelect Event Listener ==========
  // $("#welfare-level-select").on("change", function() {
  //   console.log($(this))
  // })

  let welfareLevelSelect = document.getElementById('welfare-level-select')
  if (welfareLevelSelect !== null ) {
    welfareLevelSelect.addEventListener("change", (e) => {
      console.log(e.target.value);
      var value = e.target.value;
      var text = e.target.options[e.target.selectedIndex].text;
      // Set selected welfare level
      SelectedWelfareLevel = value;
      console.log("selected welfare level: ", SelectedWelfareLevel)
      WelfareLevelSet = true

      // Display welfare package pricing based on selected welfare level
      displayWelfarePricingContainer()
     
      // Get welfare-proceed-to-cart activate
      if (welfare_proceed_to_cart !== null) {
        // welfare_proceed_to_cart.disabled = false;
        welfare_proceed_to_cart.classList.remove("hidden");
      }
    })
  }

  
  // ============= Set the Global Products Type ===========
  ProductsType =  getProductsType()
  IsWelfareProducts = getIsWelfareProductsBoolean()
  IsComboPage = getIsComboPageBoolean()
  IsCollaboPage = getIsCollaboPageBoolean()

  // ================= Set Variable Maybe DisplayCart on Page Load =========
  DisplayCartOnPageLoad = getDisplayCartModalOnPageLoadBoolean()


  //========== Maybe clear cart on page load depending on payment status, page or product type ====================
  let clearCartInput = document.getElementById('clear-cart')
  let clearRegularCartItemsInput = document.getElementById('clear-regular-cart-items')
  let clearWelfareCartItemsInput = document.getElementById('clear-welfare-cart-items')

  // if retry cart, do nothing here, modal func will take care of that
  // let retryCartPaymentInput = document.getElementById('retry-cart')

  // if clear cart, clear all cart on page load.
  if (clearCartInput !== null ){
    let clearCart = clearCartInput.value
    if (clearCart) {
      shoppingCart.clearCart();
      console.log("cart cleared");
      renderCart();
    }
  }

   // if clear regular cart items, then call clearRegularCartItems on cart object
  if (clearRegularCartItemsInput !== null ){
    let clearRegularCartItems = clearRegularCartItemsInput.value
    if (clearRegularCartItems) {
      shoppingCart.removeRegularProductFromCart();
      console.log("regular cart items cleared");
      // shoppingCart.clearCart();
      // console.log("all cart items cleared");
      renderCart();
    }
  }

  // if clear welfare cart items, then call clearWelfareCartItems on cart object
  if (clearWelfareCartItemsInput !== null ){
    let clearWelfareCartItems = clearWelfareCartItemsInput.value
    if (clearWelfareCartItems) {
      shoppingCart.removeWelfareProductFromCart();
      // TODO: Debug why all welfare products are not cleared
      console.log("maybe welfare cart items cleared");
      renderCart();
    }
  } 

  // if currency is passed in url, then clear cart. TODO: clear items with different currency
  clearCartIfUrlCurrencyIsSet()
  
  // Render the cart initially
  renderCart();

  // Display the Cart Modal
  // Should be done only once
  setTimeout(function() {
    displayLoadedCartOnPageLoad()
  }, 1000)
  
});


export function clearCartIfUrlCurrencyIsSet() {
  const urlParams = new URLSearchParams(window.location.search);
  let currency = urlParams.get('currency');
  if (currency !== null && currency != "") {
    currency = currency.trim()
    // Check existing cart currency, if different, then clear
    if (cartItemCurrencyMismatch(currency)) {
      shoppingCart.clearCart();
      console.log("url currency detected, cart currency mismatch detected, all cart items cleared");
      renderCart();
    }
  } 
}

export function hideCart() {
  $("#hide-cart").trigger("click")
}

export function disableOrderNowButton() {
  let order_button = document.getElementById('order-now')
  if (order_button !== null) {
    order_button.disabled = true;
  }
}

export function activateOrderNowButton() {
  let order_button = document.getElementById('order-now')
  if (order_button !== null) {
    order_button.disabled = false;
  }
}

export function displayLoadedCartOnPageLoad() {
  console.log("cart items", shoppingCart.getCartItemCount())
  // Check if DisplayCartOnPageLoad is active
  if (!(DisplayCartOnPageLoad || IsWelfareProducts)) {
    console.log("display cart on page load is not true or active or 1, it is:", DisplayCartOnPageLoad)
    console.log("is welfare products page:", IsWelfareProducts)
    return
  }


  if (shoppingCart.getCartItemCount() < 1) {
    // No item to display.
    console.log("no items in cart to display")
    return
  }

  let cartItemsButton = document.getElementById('cart-items')
  if (cartItemsButton !== null) {
    console.log("cart items button click triggered: ", cartItemsButtonClickTriggered)
    if (!cartItemsButtonClickTriggered) {
      console.log("clicking cartItemsButton")
      effectModalShowBodyReset()
      cartItemsButton.click()
      cartItemsButtonClickTriggered = true;

      // Trigger Cart Order Button Click
      setTimeout(function() {
        maybeClickCartOrderButtonForDisplayCartURL()
      }, 1000)
    }
  }  
}

export function maybeClickCartOrderButtonForDisplayCartURL() {
  let cartOrderButton = document.getElementById('order-now');

  const urlParams = new URLSearchParams(window.location.search);
  let displayCart = urlParams.get('display_cart');
  displayCart = displayCart.toLowerCase()
  let clickOrderButton = false
  if (displayCart !== null && displayCart != "") {
    if ( displayCart == "true" || displayCart == true || displayCart == "1" || displayCart == 1) {
      clickOrderButton = true;
    }
  }

  // Handle clicking the OrderNow button on displayed cart
  if (cartOrderButton !== null) {
    if (clickOrderButton) {
      cartOrderButton.click();
      console.log("cart order button clicked")
    } else {
      console.log("no display_cart in url, so cannot click order button, can only display cart")
    }
  }
}

export function displayWelfarePricingContainer() {

  if (!WelfareLevelSet) {
    // No welfare level selected yet, return
    return false
  }
  console.log("current welfare formatted price", welfarePackageFormattedPrice)

  // Set the formatted price for current welfare package
  if (welfareTotalAmount !== null) {
    welfareTotalAmount.textContent = welfarePackageFormattedPrice
  }

  // Calculate and set the price for the selected welfare level and package
  let welfarePackageLevelPrice = ((SelectedWelfareLevel / 100) * welfarePackagePrice)
  let formattedWelfarePackageLevelPrice = formatCurrency(welfarePackageLevelPrice, getCurrency())

  console.log("formatted welfare package level price", welfarePackageLevelPrice)

  if (welfareLevelAmount !== null) {
    welfareLevelAmount.textContent = formattedWelfarePackageLevelPrice
  }

  // Display the welfare pricing container
  if (welfarePricingContainer !== null) {
    welfarePricingContainer.classList.remove("hidden")
    welfarePricingContainer.classList.add("flex")
  }
}

export function AddSelectedItemToCart(name, code, base_price, price, quantity) {

  let is_welfare_product = isWelfareProduct(name, code)
  var type = (is_welfare_product)? "welfare" : "regular";
  let welfare_level = SelectedWelfareLevel

  // calculate welfare price based on welfare level (welfare level/100 * price)
  let welfare_price = ((welfare_level / 100) * price)

  /*
    console.log("price is: ", price)
    console.log("base price is: ", base_price)
    console.log("welfare level is: ", welfare_level)
    console.log("welfare price is: ", welfare_price)
    console.log("welfare quantity is: ", quantity)
    console.log("===============Add Selected Item to Cart====================")
  */   
  // name, code, base_price, price, quantity, type, welfare_level, welfare_price
  shoppingCart.addItemToCart(name, code, base_price, price, quantity, type, welfare_level, welfare_price );

  renderCart();

}

export function AddSelectedItemToCartNoRender(name, code, base_price, price, quantity) {

  let is_welfare_product = isWelfareProduct(name, code)
  var type = (is_welfare_product)? "welfare" : "regular";
  let welfare_level = SelectedWelfareLevel

  // calculate welfare price based on welfare level (welfare level/100 * price)
  let welfare_price = ((welfare_level / 100) * price)

  /*
    console.log("price is: ", price)
    console.log("base price is: ", base_price)
    console.log("welfare level is: ", welfare_level)
    console.log("welfare price is: ", welfare_price)
    console.log("welfare quantity is: ", quantity)
    console.log("===============Add Selected Item to Cart====================")
  */   
  // name, code, base_price, price, quantity, type, welfare_level, welfare_price
  shoppingCart.addItemToCart(name, code, base_price, price, quantity, type, welfare_level, welfare_price );

}

// Check for regular cart item products
export function isRegularProduct(name, code) {
  console.log(name, code)
  // if cart item name or code doesn't include welfare, then it's a welfare product (return not welfare product)
  name = name.toLowerCase()
  code = code.toLowerCase()
  return !((name.includes("welfare") || code.includes("welfare") ))
};

// Check for welfare cart item products
export function isWelfareProduct(name, code) {
  console.log(name, code)
  // if cart item name or code includes welfare, then it's a welfare product
  name = name.toLowerCase()
  code = code.toLowerCase()
  return (name.includes("welfare") || code.includes("welfare") )
};

export function cartItemCurrencyMismatch(currency) {
  var cartArray = shoppingCart.listCart();
  var mismatch = false;
  for (var i in cartArray) {
    if (cartArray[i].currency !== currency) {
      mismatch = true
    }
  }
  return mismatch
}

// Get Currency. Default is "USD"
export function getCurrency() {
  let currency = "USD"
  let currencyInput = document.getElementById('country-currency')
  if (currencyInput !== null){
    currency = currencyInput.value.trim()
    console.log("currency is ", currency)
  }
  return currency
}

// Get CurrencySymbol
export function getCurrencySymbol() {
  let currencySymbol = "$"
  let currencySymbolInput = document.getElementById('country-currency-symbol')
  if (currencySymbolInput !== null){
    currencySymbol = currencySymbolInput.value
    console.log("currency symbol is ", currencySymbol)
  }
  return currencySymbol
}

// Get Page Products Type
export function getProductsType() {
  let products_type = "regular"
  let welfareTypeInput = document.getElementById('is_welfare_products')
  if (welfareTypeInput !== null){
    if (welfareTypeInput.value) {      
      products_type = "welfare"
    }
    console.log("products type is: ", products_type)
  }
  return products_type
}

// Is Welfare Products
export function getIsWelfareProductsBoolean() {
  let is_welfare_products = false
  let welfareTypeInput = document.getElementById('is_welfare_products')
  if (welfareTypeInput !== null){
    if (welfareTypeInput.value == true || welfareTypeInput.value == "true" ) {
      is_welfare_products = true
      console.log("is welfare products input value: ", welfareTypeInput.value)
      console.log("boolean is welfare products: ", is_welfare_products)
    }
  }
  return is_welfare_products
}

// Is Combo Page
export function getIsComboPageBoolean() {
  let is_combo_page = false
  let comboTypeInput = document.getElementById('is_combo_page')
  if (comboTypeInput !== null){
    if (comboTypeInput.value == true || comboTypeInput.value == "true" ) {
      is_combo_page = true
      console.log("is combo page input value: ", comboTypeInput.value)
      console.log("boolean is combo page: ", is_combo_page)
    }
  }
  return is_combo_page
}

// Is Collabo Page
export function getIsCollaboPageBoolean() {
  let is_collabo_page = false
  let collaboTypeInput = document.getElementById('is_collabo_page')
  if (collaboTypeInput !== null){
    if (collaboTypeInput.value == true || collaboTypeInput.value == "true" ) {
      is_collabo_page = true
      console.log("is collabo page input value: ", collaboTypeInput.value)
      console.log("boolean is collabo page: ", is_collabo_page)
    }
  }
  return is_collabo_page
}

// Display Cart Modal On Page Load
export function getDisplayCartModalOnPageLoadBoolean() {
  let display_cart_modal_on_page_load = false
  let displayCartInput = document.getElementById('display-cart-on-page-load')
  if (displayCartInput !== null){
    let displayCartValue = displayCartInput.value
    if (displayCartValue == true || displayCartValue == "true" || displayCartValue == "active" || displayCartValue == 1 || displayCartValue == "1") {      
      display_cart_modal_on_page_load = true
      console.log("display cart input value: ", displayCartValue)

      console.log("boolean display cart on page load modal: ", display_cart_modal_on_page_load)
    }
  }
  return display_cart_modal_on_page_load
}


export function getCurrencyFormatter(currencyCode) {
  if (currencyCode == "") {
    currencyCode = "USD"
  }
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode
  });
}

export function formatCurrency(amount, currency) {
  let currencyFormatter = getCurrencyFormatter(currency)
  return currencyFormatter.format(Number(amount))
}

export function formatCurrencyParts(amount, currency) {
  let numberFormatter = getCurrencyFormatter(currency)
  return numberFormatter.formatToParts(Number(amount))
}

export function getEffectiveItemPrice(item) {
  let item_price = Number(item.price)
  // if (isWelfareProduct(item.name, item.code)) {
  //   item_price = Number(item.welfare_price)
  // }
  return item_price
}


export function recommenderEngine() {

  // We might need the hostname from window.location.href

  // Do not show recommedations for welfare products
  if (IsWelfareProducts) {
    return "";
  }
  // Do not show recommendations for Combo offers
  if (IsComboPage || IsCollaboPage) {
    return "";
  }

  if (!containsCoaching && !containsTeaching && !containsEguide) {
    return "";
  }

  let recommendationAvailable = false;

  recommendedProductsRender = '<div class="flex w-full p-2 pb-5 md:p-4 mb-6 bg-green-50 flex-col md:flex-row md:items-center text-sm">'

  if (containsCoaching && !(containsTeaching || containsEguide)) {
    // Recommend Teaching or E-Guide
    // teachings page = /teachings
    recommendedProductsRender += '<div class="flex flex-row mb-2 md:mb-0 items-center"><p class="md:mb-0"><span class="font-bold text-slate-900 text-base">Recommended:</span></p><div class="upsells-point ml-2 mr-2 md:mr-4 rounded-full bg-green-600 h-2 w-2"></div></div><div class="upsells flex flex-col lg:flex-row gap-2 lg:items-center justiify-center"><a href="/e-guides" class="eguides-upsell"><span class="font-bold text-sm bg-green-200 p-2 py-2 rounded-md flex">E-Guide</span></a> <div>OR</div> <a href="/teachings" class="teachings-upsell" ><span class="font-bold text-sm bg-green-200 p-2 py-2 rounded-md">Pinkbluers Method Lessons</span></a></div>'

    recommendationAvailable = true;
  }

  if ((containsTeaching && !(containsCoaching)) || (containsEguide && !(containsCoaching))) {
    // Recommend Coaching
    // coaching page = /private-coaching
    recommendedProductsRender += '<div class="flex flex-row mb-2 md:mb-0 items-center"><p class="md:mb-0"><span class="font-bold text-slate-900 text-base">Recommended:</span></p><div class="upsells-point ml-2 mr-2 md:mr-4 rounded-full bg-green-600 h-2 w-2"></div></div> <div class="upsells flex flex-col gap-2 justify-center"><a href="/private-coaching" class="">Add <span class="private-coaching-upsell font-bold text-sm bg-green-200 p-2 py-2 rounded-md">Private Coaching</span></a></div>'

    recommendationAvailable = true
  }

  recommendedProductsRender += '</div>'

  if (!recommendationAvailable) {
    return "";
  }

  return recommendedProductsRender

}

export function trackCartItems(item) {
  let productCode = item.code.toLowerCase()
  if (productCode.includes("coaching")) {
    containsCoaching = true;
  }

  if (productCode.includes("full")) {
    containsFullPackage = true;
    containsCoaching = true;
    containsTeaching = true;
    containsEguide = true;
  }

  if (productCode.includes("teaching")) {
    containsTeaching = true;
  }

  if (productCode.includes("eguide")) {
    containsEguide = true;
  }
}

export function resetTrackedCartItems() {
  containsFullPackage = false;
  containsCoaching = false;
  containsTeaching = false;
  containsEguide = false;
}

export function shakeUpsellButtons() {
  // Will not error if not item is null
  // $('#recommended-products').on('change', function(){
    // $(".private-coaching-upsell").addClass("pulsate");
    // $(".eguides-upsell").addClass("pulsate");
    // $(".teachings-upsell").addClass("pulsate");
    // })

    $(".upsells-point").addClass("pulsate");

}

export function coordinateShakeUpsellButtons() {
  let intervalHandle = setInterval(function(){
    shakeUpsellButtons()
    console.log("shaking")
  }, 1000)

  setTimeout(function(){
    clearInterval(intervalHandle);
    console.log("cleared")
  },10000)
}

// Add Shake Plugin to Jquery
// https://stackoverflow.com/a/32098064
// $("#your-element").shake(100,10,3);
/*
https://stackoverflow.com/a/26148022
$('#musics').on('change', '#want',function(e) {
    $(this).closest('.from-group').val(($('#want').is(':checked')) ? "yes" : "no");
    var ans=$(this).val();
    console.log(($('#want').is(':checked')));
});
*/
export function jqueryShake(selector, interval,distance,times){
  interval = typeof interval == "undefined" ? 100 : interval;
  distance = typeof distance == "undefined" ? 10 : distance;
  times = typeof times == "undefined" ? 3 : times;
  var jTarget = $(selector);
  jTarget.css('position','relative');
  for(var iter=0;iter<(times+1);iter++){
     jTarget.animate({ left: ((iter%2==0 ? distance : distance*-1))}, interval);
  }
  return jTarget.animate({ left: 0},interval);
}

export function renderCart() {
  var cartArray = shoppingCart.listCart();
  var output = "";
  var item_count = 0;
  resetTrackedCartItems();
  for (var i in cartArray) {
    item_count ++;
    trackCartItems(cartArray[i])
    var formattedAmount = formatCurrency(Number(cartArray[i].total), cartArray[i].currency)

    var effective_price = getEffectiveItemPrice(cartArray[i])
    var formatted_effective_price =  formatCurrency(Number(effective_price), cartArray[i].currency)

    // Doesn't work for Eur. For Whatever Reason.
    // var effective_display_price = formatted_effective_price.substring(3);

    // (${cartArray[i].currency_symbol})

    // console.log("effective price parts",formatCurrencyParts(Number(effective_price), cartArray[i].currency))

    output += 
    `<div class="container rounded-lg border border-solid border-1 border-slate-200 mb-4 py-3 shadow-md">

    <div class="flex flex-1 mb-2">
      <div class="product-code-container">
        <p class="font-bold text-sm md:text-base text-balance text-stepup-darkblue product-code">${cartArray[i].name}</p>
      </div>
      <div class="flex flex-1 w-full justify-end items-center card-header">
        <button id="delete-item" data-name="${cartArray[i].name}" class="flex w-6 h-6 text-white items-center justify-center font-bold text-center text-l bg-red-400 hover:bg-red-500 rounded-full delete-item">&times;</button>
      </div>
    </div>
    
    <div class="container flex-wrap space-x-0 md:flex-nowrap md:space-x-5 p-0 md:py-3 flex flex-col md:flex-row product-row rounded-md">  
    
      <div class="flex justify-between items-center product-price-container">
        <span class="mr-2 text-sm md:text-base">Price:</span>
        <div>
          <span class="currency-symbol text-sm md:text-base"></span>
          <span class="product-price text-sm md:text-base">${formatted_effective_price}</span>
        </div>
      </div>
    
      <div class="hidden space-x-0 md:flex-nowrap md:space-x-5 items-center justify-between qty-actions">
        <span class="mr-1 qty-label text-sm md:text-base">Qty:</span>
        <input data-name="${cartArray[i].name}" class="item-quantity rounded-md mr-1 bg-slate-100 w-20 p-1 md:p-2" type="number" min="0" value="${cartArray[i].quantity}">
        <button data-name="${cartArray[i].name}" class="text-slate-900 rounded-md w-8 h-8 md:w-a0 md:h-10 p-1 bg-slate-300 hover:bg-slate-400 font-semibold minus-item">-</button>
        <button data-name="${cartArray[i].name}" class="text-white rounded-md w-8 h-8 md:w-a0 md:h-10 p-1 bg-slate-400 hover:bg-slate-500 font-semibold plus-item">+</button>    
      </div>
    
      <div class="flex justify-between items-center product-cost-container">
        <span class="mr-2 text-sm md:text-base">Amount:</span>
        <div>
          <span class="currency-symbol"></span>
          <span class="font-bold product-cost text-sm md:text-base">${formattedAmount}</span>
        </div>
      </div>

    </div>
  
  </div>`      
  }

  if (output == "") {
    // No item was found in cart
    output = `
      <div class="container px-0 flex flex-col justify-center empty-cart">
        <p class="font-bold text-slate-800">Your cart is empty...</p>
        <button class="add-item-to-cart --pb-modal-close" rounded-md bg-green-500 text-white hover:bg-green-600 px-4 py-2 mt-2">Click Here to Add Items to Your Cart<button>
      </div>
    `
    disableOrderNowButton();
  } else {
    // Items exists in cart, activate OrderNowButton
    activateOrderNowButton();
  }

  $(".show-cart").html(output);
  $(".total-cart").html(formatCurrency(shoppingCart.totalCart(), getCurrency()));
  $(".total-count").html(shoppingCart.totalCartItemsCount());
  $(".recommended-products").html(recommenderEngine());
  // Shake recommendations if any
  shakeUpsellButtons();
}

export async function processCartOrderPaymentRequest(e) {

  const gateway = e.currentTarget.getAttribute('data-gateway')
  console.log("payment gateway: ", gateway)

  let paymentMethod = gateway.includes("bank") ? "bank" : "gateway"
  let ipAddressInput = document.getElementById("request-ip-address")
  let ipAddress = (ipAddressInput !== null)? ipAddressInput.value : ""


  // Check if we should rebuild cart before proceeding
  if (RebuildComboCart) {
    rebuildComboCartWithIndividualItems()
  }

  // Add Info from different pages
  addCustomPagesExtraInfo()

  let cartItems = shoppingCart.listCart()
  let cartTotal = shoppingCart.totalCart()

  let response = {};
  
  let cartOrder = {
    order_items: cartItems,
    payment_method: paymentMethod, 
    payment_gateway: gateway,
    ip_address: ipAddress,     
    order_type: ProductsType,
    order_total: cartTotal, 
    welfare_level:  Number(SelectedWelfareLevel), // Avoid unmarshal errors
    order_page: XderPage,
    order_extra_info: XtraZnfo
  }

  console.log(cartOrder)
  
  response = await postCartOrderPaymentRequest(cartOrder)
  console.log(response)

  // Now, we have the reponse
  if (response.hasOwnProperty('data')) {

    let transactionID =  response.data.transaction_id;
    let orderID =  response.data.order_id;
    let userID =  response.data.user_id;
    // let paymentID =  response.data.payment_id;
    let formattedTransferAmount = response.data.formatted_payment_amount;
    
    // Build the Transaction Details and Display on UI
    /*
      <span id="transaction-details" class=" transaction-id text-sm font-bold">TransactionID:
          txn-HD8DLI2DHLSLWSH89J8, UserID: txn-HD8DLI2DHLSLWSH89J8, OrderID: txn-HD8DLI2DHLSLWSH89J8, Amount: NGN 250,000</span>
    */
    let formattedTransactionDetails = "";
    formattedTransactionDetails += 'TransactionID: ' + transactionID;
    formattedTransactionDetails += ', UserID: ' + userID;
    formattedTransactionDetails += ', OrderID: ' + orderID;
    formattedTransactionDetails += ', Amount: ' + formattedTransferAmount;


    // Foreach total-transfer-amount,
    Array.from(document.getElementsByClassName('total-transfer-amount')).forEach(el => {
      el.textContent = formattedTransferAmount;
    })
    
    // Foreach transaction-details, add the details
    Array.from(document.getElementsByClassName('transaction-details')).forEach(el => {
        el.textContent = formattedTransactionDetails;
      })

    } else {
      console.log("response object doesn't contain data object", response)
    }



}

// https://rapidapi.com/guides/error-handling-fetch
// https://stackoverflow.com/questions/39735496/redirect-after-a-fetch-post-call
async function postCartOrderPaymentRequest(cartOrder) {
  // Code to submit the cartOrder to the server
  // Here, we'll use the fetch() function to POST the data to an API endpoint
  return fetch('/cart/process-cart-order-payments', {
      method: 'POST',
      body: JSON.stringify(cartOrder),
      mode: 'cors',
      // redirect:'manual',
      headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
      },
  })
  .then(response => {
      // If server error occurred, throw error
      if (response.status >= 500) {
        throw new Error('Server error');
      }
      return response.json();
  })
  .then(data => {
      // Handle the response from the server
      console.log(data);
      if (!data.error) {
        console.log(data.message) 
        
        if (!(data.data.payment_method.includes("bank")) && (data.data.payment_link !== "")) {
          // must be a gateway payment
          window.location.replace(data.data.payment_link)
        }
        return data;
      } else {
          console.log(data.message)
          return data;          
      }
  })
  .catch(error => {
      // Handle any errors that occur during form submission
      console.error(error);
      return error;
  });

}



// =============== Cart Clearing Events ====================
// https://learn.jquery.com/using-jquery-core/document-ready/

// $( document ).ready( readyFn ); fires when DOM is ready (deprecated. Use shorthand version)
// or:
// $( window ).on( "load", readyFn ); fires when DOM is ready with Images and Iframes
// Shorthand for $( document ).ready()
// $(function() {
//   console.log( "ready!" );
// });

// Shorthand for deprecated $( document ).ready()
// Run DOM ready functions


/*

let oldCartProductCard = "<tr>" +
"<td>" +
cartArray[i].name +
"</td>" +
"<td>(" +
cartArray[i].price +
")</td>" +
"<td><div class='input-group'><button class='minus-item input-group-addon btn btn-primary text-white bg-blue-500' data-name=" +
cartArray[i].name +
">-</button>" +
"<input type='number' class='w-12 item-quantity form-control' data-name='" +
cartArray[i].name +
"' value='" +
cartArray[i].quantity +
"'>" +
"<button class='plus-item btn btn-primary input-group-addon' data-name=" +
cartArray[i].name +
">+</button>" +
"<button class='delete-item btn btn-danger text-white bg-red-500' data-name=" +
cartArray[i].name +
">X</button></div></td>" +      
"<td>" +
" = " +
cartArray[i].total +
"</td>" +
"</tr>";
*/



// Export from Module
// Since we want a singleton, 
// the class is instantiated as an iife(function(){})()
// module.exports = {
//   shoppingCart, displayCart
// };


/* =============CSS=================
  body {
    padding-top: 80px;
  }
  
  .show-cart li {
    display: flex;
  }
  .card {
    margin-bottom: 20px;
  }
  .card-img-top {
    width: 200px;
    height: 200px;
    align-self: center;
  }


  ===============HTML=============
<!-- Nav -->
<nav class="navbar navbar-inverse bg-inverse fixed-top bg-faded">
    <div class="row">
        <div class="col">
          <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#cart">Cart (<span class="total-quantity"></span>)</button><button class="clear-cart btn btn-danger">Clear Cart</button></div>
    </div>
</nav>


<!-- Main -->
<div class="container">
    <div class="row">
      <div class="col">
        <div class="card" style="width: 20rem;">
            <img class="card-img-top" src="http://www.azspagirls.com/files/2010/09/orange.jpg" alt="Card image cap">
            <div class="card-block">
                <h4 class="card-title">Orange</h4>
                <p class="card-text">Price: $0.5</p>
                <a href="#" data-name="Orange" data-price="0.5" class="add-to-cart btn btn-primary">Add to cart</a>
            </div>
        </div>
      </div>
      <div class="col">
        <div class="card" style="width: 20rem;">
            <img class="card-img-top" src="http://images.all-free-download.com/images/graphicthumb/vector_illustration_of_ripe_bananas_567893.jpg" alt="Card image cap">
            <div class="card-block">
                <h4 class="card-title">Banana</h4>
                <p class="card-text">Price: $1.22</p>
                <a href="#" data-name="Banana" data-price="1.22" class="add-to-cart btn btn-primary">Add to cart</a>
            </div>
        </div>
      </div>
        <div class="col">
            <div class="card" style="width: 20rem;">
                <img class="card-img-top" src="https://3.imimg.com/data3/IC/JO/MY-9839190/organic-lemon-250x250.jpg" alt="Card image cap">
                <div class="card-block">
                    <h4 class="card-title">Lemon</h4>
                    <p class="card-text">Price: $5</p>
                    <a href="#" data-name="Lemon" data-price="5" class="add-to-cart btn btn-primary">Add to cart</a>
                </div>
            </div>
      </div>
    </div>
</div>

  
 <!-- Modal -->
<div class="modal fade" id="cart" tabindex="-1" role="dialog" aria-labelledby="cartModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="cartModalLabel">Cart</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="show-cart table">
          
        </table>
        <div>Total price: $<span class="total-cart"></span></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Order now</button>
      </div>
    </div>
  </div>
</div> 


  */
